/**
 * Shared visual shell for Aura conversation card types — one editorial recipe.
 */
import React from 'react';

const TYPE_LABELS = {
  strategy: 'Strategy',
  progress: 'Progress',
  routing: 'Routing',
  proposal: 'Proposal',
  advisor_response: 'Advice',
  text: 'Reflection',
  default: 'Aura',
};

const EMPHASIS_TYPES = new Set(['strategy', 'proposal']);

const AuraCardShell = ({ type, title, badge, children, className = '' }) => {
  const label = badge || TYPE_LABELS[type] || TYPE_LABELS.default;
  const emphasis = EMPHASIS_TYPES.has(type);

  return (
    <div className={`aura-card light-surface ${emphasis ? 'border-t-2 border-t-pine' : ''} ${className}`}>
      {(title || label) && (
        <div className="flex items-start justify-between gap-2 mb-3 pb-3 border-b border-hairline">
          {title && <h4 className="font-sans text-h3 text-ink">{title}</h4>}
          <span className="text-label text-ink-muted shrink-0">{label}</span>
        </div>
      )}
      {children}
    </div>
  );
};

export default AuraCardShell;
